export default __webpack_public_path__ + "static/media/degree_pre_next.21eb1cc2.png";